<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      if (!Array.isArray(this.form.items)) {
        this.$set(this.form, 'items', [])
      }
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.WYSIWYG({
              label: 'Title',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => {
                return {
                  headerLabel: 'Box item',
                  fields: [
                    new fields.WYSIWYG({
                      label: 'Box title',
                      modelPath: [this, 'form', 'items', i, 'title'],
                      multilingual: true,
                      required: true
                    }),
                    new fields.WYSIWYG({
                      label: 'Box "Core" text',
                      modelPath: [this, 'form', 'items', i, 'core'],
                      multilingual: true
                    }),
                    new fields.WYSIWYG({
                      label: 'Box "External examinations" text',
                      modelPath: [
                        this,
                        'form',
                        'items',
                        i,
                        'external_examinations'
                      ],
                      multilingual: true
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  }
}
</script>
